import { FunctionComponent } from 'react';
import { BodyText, Button, Div, Headline } from '@gaiads/telia-react-component-library';

interface CommonErrorContentProps {
  title: string;
  subtitle?: string;
  content: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const CommonErrorContent: FunctionComponent<CommonErrorContentProps> = ({ title, subtitle, content, buttonText, onButtonClick }) => (
  <Div padding={{ top: 'xxlg', horizontal: 'xxlg' }}>
    <Headline size="md" block>
      {title}
    </Headline>
    {subtitle && (
      <BodyText margin={{ top: 'xlg', bottom: 'sm' }} padding={{ top: 'md' }} fontWeight="bold" color="gray800">
        {subtitle}
      </BodyText>
    )}
    <BodyText margin={subtitle ? { bottom: 'xxlg' } : { top: 'xlg', bottom: 'xxlg' }} padding={subtitle ? undefined : { top: 'md' }} color="gray800">
      {content}
    </BodyText>
    {buttonText && onButtonClick && (
      <Button variant="secondary" size="lg" onClick={onButtonClick}>
        {buttonText}
      </Button>
    )}
  </Div>
);

export default CommonErrorContent;
